import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack, useTheme, useMediaQuery } from "@mui/material";
import Question from "../../components/Question";
import MoveButton from "../../components/MoveButton";
import CustomSpinner from "../../components/CustomSpinner";
import { callBackendApiGet } from "../../lib/api";
import { setPatients, setSelectedPhotosPatient } from "../../redux/userSlice";
import logDrtEvent from '../../lib/logging';

export default function PhotosPatientSelection() {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const [loading, setLoading] = useState(true);
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        if (hasFetchedRef.current) return;

        if (!user.patients || user.patients.length === 0) {
            fetchPatientData();
        } else {
            setLoading(false);
        }

        hasFetchedRef.current = true;
    }, [user.patients]);

    const fetchPatientData = async () => {
        try {
            setLoading(true);
            const encodedPhoneNo = encodeURIComponent(user.phoneNo);
            const response = await callBackendApiGet(`/api/v1/patient-to-upload-images?phone=${encodedPhoneNo}`);

            if (response.status !== 200) {
                throw new Error(`Failed to fetch patients: ${response?.status}`);
            }

            const data = await response.json();

            if (!data || !Array.isArray(data)) {
                throw new Error("Invalid response format for returning_patients");
            }

            dispatch(setPatients(data));

            if (data.length === 1) {
                handlePatientSelection(data[0]);
            } else if (data.length === 0) {
                navigate("/concern", { state: { returning: false } });
            }
        } catch (err) {
            logDrtEvent(`Error while fetching patients with phone number: ${err}`);
            navigate("/error", { state: { photos: true } });
        } finally {
            setLoading(false);
        }
    };

    const handlePatientSelection = (patient) => {
    dispatch(setSelectedPhotosPatient(patient));
    navigate("/photos-cases");
};

    if (loading || !user.patients || user.patients.length === 0) {
        return <CustomSpinner />;
    }

    return (
        <Question
            noBack
            title="Select a patient"
            subtitle="Who are these photos for?"
            input={
                <Box display="flex" flexDirection="column" alignItems="center" width="100%">
                    <Stack spacing={2} width="100%" maxWidth="sm" alignItems="center">
                        {user?.patients.map((patient, index) => (
                            <MoveButton
                                key={index}
                                onClick={() => handlePatientSelection(patient)}
                                title={patient.full_name}
                                selected={false}
                                sx={{ width: isDesktop ? "100%" : "100%", maxWidth: "400px" }}
                            />
                        ))}
                    </Stack>
                </Box>
            }
        />
    );
}
